module.exports = __webpack_public_path__ + "static/img-how-use-89a7a931a7bb91d04b4042b83cf03e5c.png";